import config from '../config/config.json';
import Placeholder from '../config/placeholder.config';

const strengths = ['Mellow', 'Mellow-Medium', 'Medium', 'Medium-Full', 'Full'];

export default class Cigar {
  constructor(item) {
    this.brand = item.brand;
    this.name = item.name;
    this.fullName = item.full_name;
  }
}

Cigar.getImage = (cigar) => {
  if (cigar) {
    if (cigar.images && cigar.images.length) {
      for (let i = 0; i < cigar.images.length; i++) {
        const image = cigar.images[i];
        if (image.image_type === 6 && image.approved) {
          // 'Display' image type
          return `${config.mediaEndPoint}/transforms/background/transparent?key=${image.image_uri.substring(1)}`;
        }
      }
    }
    if (cigar.image_uri && cigar.image_uri.indexOf('.jpg') === -1) {
      // INFO For now, these legacy images aren't on the new CDN, use the old one
      // They should be handled on the Lambda server for resizing - if the base size doesn't exist,
      // pull from Sigaro and push to Boxpressd
      return `${config.mediaEndPoint}/transforms/background/transparent?key=${cigar.image_uri.replace('boxpressd', 'sigaro').substring(1)}`;
    }
    if (cigar.image_uri) {
      return `${config.mediaEndPoint}/transforms/background/transparent?key=${cigar.image_uri.substring(1)}`;
    }
  }
  return Placeholder.cigar;
};

Cigar.getDisplayImage = (cigar, transparent = true) => {
  if (cigar) {
    if (cigar.images && cigar.images.length) {
      for (let i = 0; i < cigar.images.length; i++) {
        const image = cigar.images[i];
        if (image.image_type === 6 && image.approved) {
          // 'Display' image type
          if (transparent) {
            return `${config.mediaEndPoint}/transforms/background/transparent?key=${image.image_uri.substring(1)}`;
          }
          return image.image_url;
        }
      }
    }
  }
  return Placeholder.cigar;
};

Cigar.getBandImage = (cigar) => {
  if (cigar) {
    if (cigar.images && cigar.images.length > 0) {
      for (let i = 0; i < cigar.images.length; i++) {
        if (
          cigar.images[i].image_type === 0 &&
          cigar.images[i].approved === true
        ) {
          return cigar.images[i].image_url; // FIXME If image_type == 0 isn't available, use next option? 1 for full band?
        }
      }
    }
  }
  return Placeholder.band;
};

// FIXME Why is this 0-based? The strengths are 1-based
Cigar.formattedStrength = (strengthInt) => {
  if (strengths[strengthInt]) {
    return strengths[strengthInt];
  }
  return 'Unknown';
};

Cigar.strengths = strengths;
